// extracted by mini-css-extract-plugin
export default {"main":"GLifosMetadata_main__k9+BN","options":"GLifosMetadata_options__7p2vv","item":"GLifosMetadata_item__QUADe","title":"GLifosMetadata_title__7n0rd"};